export const getImageSource = () => Promise.resolve({ uri: '' });
export const getImageSourceSync = () => ({ uri: '' });
export default {
  getImageSource,
  getImageSourceSync,
};
